import config from '../config';
import postal from 'postal';
import _ from 'lodash';
import constants from '../constants';
import { useContext } from 'react';
import ApplicationContext from '../ApplicationContext';
import { GenEmailArgs } from '../fms.report/args';
import { DocumentType } from '../framework.core/DocumentType';
import { getFmsGlobal } from '../globals';
import { nowDate } from '../dateUtils';
import moment from 'moment';
import useSuntekSettings from './useSuntekSettings';

export default function useReportViewer() {
  /**
   * Publish request-to-open-report-opTab
   * @param reportArgs 
   * @param opType {optional constants.opType, default = accounting}
   */

  const appContext = useContext(ApplicationContext);
  const suntekSettings = useSuntekSettings();

  function checkPopupAvailable() {
    let result = true;

    //check report popup
    let n1 = window.open(config.serverUrl,
      '_blank',
      `toolbar=no, location=no, directories=no, status=no, menubar=no, width=10, height=10, left=${window.innerWidth - 10},top=${window.innerWidth - 10}`);
    // show bottom right corner of the screen.
    if (n1 == null) {
      result = false;
    } else {
      n1.close();
    }

    let n2 = window.open(config.serverUrl,
      '_blank',
      `toolbar=no, location=no, directories=no, status=no, menubar=no, width=15, height=15, left=${window.innerWidth - 10},top=${window.innerWidth - 10}`);
    // show bottom right corner of the screen.
    if (n2 == null) {
      // alert
      //console.log('viewReport - test')
      result = false;
    } else {
      n2.close();
    }

    return result;
  }

  function viewReport(reportArgs: any, opType?: string, popup: boolean = false, hlink: boolean = false, multi: boolean = false) {
    (document.activeElement as HTMLElement).blur()

    if(reportArgs && !hlink){
      //Report Print Preiview에서 Export Button 표시하지 않기 위해 추가
      reportArgs.blockExportButton = suntekSettings.general?.blockExportButton??false;
    }
    if(!checkPopupAvailable()){
      alert('Please allow popups for this website.');
      return;
    }

    if (!popup) {
      var channel = postal.channel('report');
      // Caution: operation is not same as opType
      //if(!opType) opType = _.keys(constants.operations).find(k => constants.operations[k] === lastOperation);
      if (!opType) opType = constants.opTypes.accounting;
      channel.publish('report.view', {
        reportId: _.isObject(reportArgs) ? JSON.stringify(reportArgs) : reportArgs,
        opType,
        jwt: appContext.api.getAuthKey()
      });
    } else if (multi) {
      window.open(`${config.serverUrl}report?argsType=multi&args=${hlink ? 'hlink-' : ''}${encodeURIComponent(hlink ? reportArgs : JSON.stringify(reportArgs))}&jwt=${appContext.api.getAuthKey()}`,
      '_blank'
      );
    } else {
      // let left = (document.body.offsetWidth / 2) - (980 / 2);
      // left += window.screenLeft;
      window.name = `ifmsmain-${appContext.user?.suntekId?.toLowerCase()}-${appContext.user?.id?.toLowerCase()}`;

      window.open(`${config.serverUrl}report?args=${hlink ? 'hlink-' : ''}${encodeURIComponent(hlink ? reportArgs : JSON.stringify(reportArgs))}&jwt=${appContext.api.getAuthKey()}`,
        '_blank'//,
        //'popup'
        //240619.dwshin. report open pattern chage - popup > tab
        //`width=980, height=${window.screen.availHeight},left=${left}, top=0, scrollbars=yes` 
      )
    }
  }


  function viewEmptyReport(faxMode: boolean = true, toCompanyList: string = '', cfsType: string = '', content: string = '', tbName: string = '', tbId: number = 0, usePopup: boolean = false
  ) {

    let reportArgs = new GenEmailArgs({
      toCompanyid: toCompanyList,
      generalMode: true,
    });

    if (faxMode) {
      reportArgs.formCaption = 'General Fax';
      reportArgs.docType = DocumentType.GenFax;
      //preview.SetViewMode((int)PrintPreviewViewMode.Fax);
      //preview.CancelButton = preview.btnFaxCancel;

    } else {
      reportArgs.formCaption = 'General Email';
      reportArgs.docType = DocumentType.GenEmail;
      if (['Manifest', 'Release'].indexOf(cfsType) >= 0) {
        reportArgs.tbName = tbName;
        reportArgs.tbId = tbId.toString();
      }

      if (toCompanyList) {
        //preview.SetViewMode((int)PrintPreviewViewMode.Email);
      } 
      
      // preview.CancelButton = preview.btnEmailCancel;
    }

    if (cfsType || content) {
      //preview.Memo = content;
      reportArgs.memo = content;
      if (content && getFmsGlobal().AcmeID4 === "STAR") {
        reportArgs.subject = "STAR ASIA COMMUNICATION " + moment(nowDate()).format('MM-DD-YYYY');
      }
      else {
        reportArgs.subject = "Various";
      }

      reportArgs.cfsType = cfsType;
    }
    if (usePopup) { 
      var left = Math.ceil((window.screen.width - 980)/2); 
      left += window.screenLeft;
      var top = Math.ceil((window.screen.height - 650)/2);    
      
      window.open(`${config.serverUrl}report?args=${encodeURIComponent(JSON.stringify(reportArgs))}&jwt=${appContext.api.getAuthKey()}`,
      '_blank', `popup, width=980, height=650, left=${left} ,top=${top},scrollbars=yes`
    )
    }

    else
      window.open(`${config.serverUrl}report?args=${encodeURIComponent(JSON.stringify(reportArgs))}&jwt=${appContext.api.getAuthKey()}`,'_blank')
  }

  return { viewReport, viewEmptyReport };
}
